import { RootState } from "@/infrastructure/rootState";

// Meta:
export const availPurchaseTypes = ({ backtest }: RootState) => backtest.meta.purchaseType;
export const availRegions = ({ backtest }: RootState) => backtest.meta.regions;
export const availTickers = ({ backtest }: RootState) => backtest.meta.tickers;
export const availIndices = ({ backtest }: RootState) => backtest.meta.indices;
export const availStrategyOptions = ({ backtest }: RootState) => backtest.meta.strategyOptions;
export const availCompareOptions = ({ backtest }: RootState) => backtest.meta.compareOptions;
export const availModelOptions = ({ backtest }: RootState) => backtest.meta.modelOptions;
